import React, { useState, useEffect } from "react";
import { baseUrl } from "../../../services/config";
import { useSelector } from "react-redux";
import { Modal, Table, Alert, Spinner } from "react-bootstrap";
import { useAlert } from "react-alert";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import Paper from "@material-ui/core/Paper";
import { PremissionChecker } from "../../../services/PremissionChecker";
const ClassSections = () => {
  const alert = useAlert();
  const authtoken = localStorage.getItem("userToken");
  const user = useSelector((state) => state.user.user);
  const [allfields, setallfields] = useState(false);
  const [startloading, setStartloading] = useState(false);
  const [loading, setloading] = useState(false);

  const [campusData, setCampusData] = useState(user.campuses || []);
  const [campusCourseData, setCampusCourseData] = useState([]);
  const [courseClassData, setCourseClassData] = useState([]);
  const [classSectionData, setClassSectionData] = useState([]);
  const [allSections, setAllSections] = useState([]);

  const [campusId, setCampusId] = useState("");
  const [courseId, setCourseId] = useState("");
  const [classId, setClassId] = useState("");

  const [addModal, setAddModal] = useState(false);
  const [addCampusId, setAddCampusId] = useState("");
  const [addCourseId, setAddCourseId] = useState("");
  const [addClassId, setAddClassId] = useState("");
  const [globalSectionId, setGlobalSectionId] = useState("");

  const [editSectionModal, setEditSectionModal] = useState(false);
  const [editClassSectionId, setEditClassSectionId] = useState("");
  const [editCampusId, setEditCampusId] = useState("");
  const [editCourseId, setEditCourseId] = useState("");
  const [editClassId, setEditClassId] = useState("");
  const [editSectionId, setEditSectionId] = useState("");

  const [deleteModal, setdeleteModal] = useState(false);
  const [deleteSection, setDeleteSection] = useState(0);
  const [deleteloading, setdeleteloading] = useState(false);

  useEffect(() => {
    getAllSections();
  }, []);

  const getAllSections = async () => {
    await fetch(`${baseUrl}/global-section`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setAllSections(data.payload);
      })
      .catch((err) => {
        console.log("vehicle", err);
      });
  };

  const handleCampusChange = (id) => {
    if (addModal) {
      setAddCampusId(id);
      getCampusCourses(id);
    } else if (editSectionModal) {
      setEditCampusId(id);
      getCampusCourses(id);
    } else {
      setCampusId(id);
      getCampusCourses(id);
    }
  };

  const getCampusCourses = async (campusId) => {
    setCampusCourseData([]);
    setCourseClassData([]);
    setClassSectionData([]);

    if (campusId == "") {
      return alert.error("Please Select Campus");
    }
    await fetch(`${baseUrl}/campus-all-courses/${campusId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setCourseId("");
          setClassId("");
          setCampusCourseData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const onCourseChange = (id) => {
    if (addModal) {
      setAddCourseId(id);
      getCourseClasses(id);
    } else if (editSectionModal) {
      setEditCourseId(id);
      getCampusCourses(id);
    } else {
      setCourseId(id);
      getCourseClasses(id);
    }
  };

  const getCourseClasses = async (courseId) => {
    setCourseClassData([]);
    setClassSectionData([]);

    if (courseId == "") {
      return alert.error("Please Select Course");
    }
    await fetch(`${baseUrl}/course-all-classes/${courseId}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setClassId("");
          setCourseClassData(data.payload);
          setloading(false);
        });
      })
      .catch((err) => {
        alert.error(err);
        setloading(false);
      });
  };

  const handleClassChange = (id) => {
    setClassId(id);
    getSectionsList(id);
  };

  const getSectionsList = (id) => {
    setClassSectionData([]);
    if (id == "" || campusId == "" || courseId == "") {
      alert.error("Please Select Campus / Course/ Class");
      return;
    }
    setloading(true);
    fetch(`${baseUrl}/class-section/${campusId}/${courseId}/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        setloading(false);
        res.json().then((data) => {
          setClassSectionData(data.payload);
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addSectionsHandler = async () => {
    if (
      addCampusId == "" ||
      addCourseId == "" ||
      addClassId == "" ||
      globalSectionId == ""
    ) {
      setallfields(true);
      return;
    }
    setStartloading(true);
    setallfields(false);
    const data = {
      campus_id: addCampusId,
      course_id: addCourseId,
      student_class_id: addClassId,
      global_section_id: globalSectionId,
    };

    await fetch(`${baseUrl}/class-section`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => {
        res.json().then((data) => {
          if (data.metadata) {
            if (data.metadata.success) {
              alert.success("Section Successfully Added");
              setAddModal(false);
              setStartloading(false);
            } else if (!data.metadata.success) {
              Object.values(data.metadata.message).map((msg) => {
                alert.error(msg);
              });
              setAddModal(false);
              setStartloading(false);
            } else {
              alert.show("Something Went Wrong");
              setAddModal(false);
              setStartloading(false);
            }
          }
        });
      })
      .catch((err) => {
        setStartloading(false);
        alert.error("Something went wrong", err);
        console.log(err);
      });
  };

  const updateSectionHandler = async () => {
    if (editCourseId == "" || editClassId == "" || editSectionId == "") {
      return alert.error("All Fields Are Required");
    }

    setStartloading(true);
    const data = {
      campus_id: editCampusId,
      course_id: editCourseId,
      student_class_id: editClassId,
      global_section_id: editSectionId,
    };
    setStartloading(false);
    await fetch(`${baseUrl}/class-section/${editClassSectionId}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          setStartloading(false);
          if (data.metadata.success) {
            alert.success("Section Successfully Updated");
            getSectionsList(classId);
            setEditSectionModal(false);
          } else if (!data.metadata.success) {
            Object.values(data.metadata.message).map((msg) => {
              alert.error(msg);
            });
            setEditSectionModal(false);
          } else {
            alert.show("Something Went Wrong");
            setEditSectionModal(false);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setStartloading(false);
      });
  };

  const deleteSectionHandle = async () => {
    setdeleteloading(true);

    await fetch(
      `${baseUrl}/class-section/${campusId}/${courseId}/${classId}/${deleteSection}`,
      {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${authtoken}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.metadata) {
          if (data.metadata.success) {
            alert.success("Section Successfully Removed");
            getSectionsList(classId);
            setdeleteloading(false);
            setdeleteModal(false);
          } else if (!data.metadata.success) {
            alert.error(data.metadata.message);
            setdeleteloading(false);
            setdeleteModal(false);
          } else {
            alert.error("Something Went Wrong");
            setdeleteloading(false);
            setdeleteModal(false);
          }
        }
      })
      .catch((err) => {
        console.log("err", err);
        setdeleteloading(false);
        setdeleteModal(false);
      });
  };

  return (
    <div>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <button
          onClick={() => setAddModal(true)}
          className="btn btn-success button_blue"
        >
          Add Section
        </button>
        <br />
        <div className="row mt-5">
          <div className="col-md-4">
            <label>
              <b>Select Campus</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="campus_id"
              aria-label="Default select example"
              onChange={(e) => {
                handleCampusChange(e.target.value);
              }}
              value={campusId}
            >
              <option value=""> Select Campus</option>
              {campusData &&
                campusData.map((item, index) => (
                  <option key={index} value={item.id}>
                    {item.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="col-md-4">
            <label>
              <b>Select Course</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              name="campus_id"
              aria-label="Default select example"
              onChange={(e) => {
                onCourseChange(e.target.value);
              }}
              value={courseId}
            >
              <option value=""> Select Course</option>
              {campusCourseData &&
                campusCourseData.map((item, index) => (
                  <option key={index} value={item?.course?.id}>
                    {item?.course?.name}
                  </option>
                ))}
            </select>
          </div>

          <div className="col-md-4">
            <label>
              <b>Select Class</b> <span style={{ color: "red" }}>*</span>
            </label>
            <select
              style={{ height: 40 }}
              className="form-select"
              aria-label="Default select example"
              onChange={(e) => {
                handleClassChange(e.target.value);
              }}
              value={classId}
            >
              <option value="">Select Class</option>
              {courseClassData &&
                courseClassData.map((courseClass, index) => (
                  <option key={index} value={courseClass.class?.id}>
                    {courseClass.class?.name}
                  </option>
                ))}
            </select>
          </div>
        </div>
        {loading ? (
          <div className="row justify-content-center">
            <Spinner
              className="text-center"
              variant="info"
              animation="border"
            />
          </div>
        ) : (
          <div>
            <Table>
              <thead>
                <tr className="text-center">
                  <td>ID</td>
                  <td>Name</td>
                  <td>Update</td>
                  {PremissionChecker(user, "campus.can_delete_section") ? (
                    <td>Delete</td>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {classSectionData.map((sectionData, index) => (
                  <tr key={index} className="text-center">
                    <td>{sectionData.id}</td>
                    <td>{sectionData.section?.name}</td>
                    <td>
                      <a
                        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                        onClick={() => {
                          setEditClassSectionId(sectionData.id);
                          setEditCampusId(sectionData.campus_id);
                          setEditCourseId(sectionData.course_id);
                          setEditClassId(sectionData.student_class_id);
                          setEditSectionId(sectionData.global_section_id);
                          setEditSectionModal(true);
                        }}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                          <SVG
                            src={toAbsoluteUrl(
                              "/media/svg/icons/Files/Download.svg"
                            )}
                          />
                        </span>
                      </a>
                    </td>
                    {PremissionChecker(user, "campus.can_delete_section") ? (
                      <td>
                        <a
                          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
                          onClick={() => {
                            setDeleteSection(sectionData?.section?.id);
                            setdeleteModal(true);
                          }}
                        >
                          <span className="svg-icon svg-icon-md svg-icon-danger">
                            <SVG
                              src={toAbsoluteUrl(
                                "/media/svg/icons/Communication/Delete-user.svg"
                              )}
                            />
                          </span>
                        </a>
                      </td>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}

        {/* Add Class Section Modal */}
        <Modal show={addModal}>
          <Modal.Header className="modal_header_style text-center" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Add Class Section
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="mt-2">
                <label>
                  <b>Select Campus</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  name="campus_id"
                  aria-label="Default select example"
                  onChange={(e) => {
                    handleCampusChange(e.target.value);
                  }}
                  value={addCampusId}
                >
                  <option value=""> Select Campus</option>
                  {campusData &&
                    campusData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="mt-2">
                <label>
                  <b>Select Course</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  name="campus_id"
                  aria-label="Default select example"
                  onChange={(e) => {
                    onCourseChange(e.target.value);
                  }}
                  value={addCourseId}
                >
                  <option value=""> Select Course</option>
                  {campusCourseData &&
                    campusCourseData.map((item, index) => (
                      <option key={index} value={item.course?.id}>
                        {item.course?.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="mt-2">
                <label>
                  <b>Select Class</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setAddClassId(e.target.value);
                  }}
                  value={addClassId}
                >
                  <option value="">Select Class</option>
                  {courseClassData &&
                    courseClassData.map((courseClass, index) => (
                      <option key={index} value={courseClass.class?.id}>
                        {courseClass.class?.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="mt-2">
                <label>
                  <b>Select Section</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select form-control"
                  onChange={(e) => {
                    setGlobalSectionId(e.target.value);
                  }}
                  aria-label="Default select example"
                  value={globalSectionId}
                >
                  <option value="">Select Section</option>
                  {allSections.map((sectionData, index) => (
                    <option key={index} value={sectionData.id}>
                      {sectionData.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </Modal.Body>
          {allfields ? (
            <div id="err">
              <Alert
                variant="danger"
                onClose={() => setallfields(false)}
                dismissible
              >
                <Alert.Heading>Please fill All fields!</Alert.Heading>
                <p>All fields Are required</p>
              </Alert>
            </div>
          ) : null}
          <Modal.Footer>
            {startloading ? (
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            ) : (
              <button
                className="btn btn-success button_blue"
                onClick={addSectionsHandler}
              >
                Add
              </button>
            )}

            <button
              onClick={() => setAddModal(false)}
              className="btn btn-danger btn_width"
            >
              Cancel
            </button>
          </Modal.Footer>
        </Modal>

        {/* Update Class Section Modal */}
        <Modal show={editSectionModal} size="md">
          <Modal.Header>
            <Modal.Title>Update Class Section</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="mt-2">
                <label>
                  <b>Select Campus</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  name="campus_id"
                  aria-label="Default select example"
                  onChange={(e) => {
                    handleCampusChange(e.target.value);
                  }}
                  value={editCampusId}
                >
                  <option value=""> Select Campus</option>
                  {campusData &&
                    campusData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="mt-2">
                <label>
                  <b>Select Course</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  name="campus_id"
                  aria-label="Default select example"
                  onChange={(e) => {
                    onCourseChange(e.target.value);
                  }}
                  value={editCourseId}
                >
                  <option value=""> Select Course</option>
                  {campusCourseData &&
                    campusCourseData.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.course?.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="mt-2">
                <label>
                  <b>Select Class</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setEditClassId(e.target.value);
                  }}
                  value={editClassId}
                >
                  <option value="">Select Class</option>
                  {courseClassData &&
                    courseClassData.map((courseClass, index) => (
                      <option key={index} value={courseClass?.class?.id}>
                        {courseClass.class?.name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="mt-2">
                <label>
                  <b>Select Section</b> <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  style={{ height: 40 }}
                  className="form-select form-control"
                  onChange={(e) => {
                    setEditSectionId(e.target.value);
                  }}
                  aria-label="Default select example"
                  value={editSectionId}
                >
                  <option value="">Select Section</option>
                  {allSections.map((sectionData, index) => (
                    <option key={index} value={sectionData?.id}>
                      {sectionData.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {startloading ? (
              <div
                style={{
                  width: "80px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <button
                onClick={updateSectionHandler}
                className="btn btn-primary"
              >
                Update
              </button>
            )}

            <button
              onClick={() => setEditSectionModal(false)}
              className="btn btn-danger"
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Class Section Modal */}
        <Modal show={deleteModal}>
          <Modal.Header className="modal_header_style" closeButton>
            <Modal.Title
              className="Modal_Heading_font"
              id="contained-modal-title-vcenter"
            >
              Are you sure want to delete this class section?
            </Modal.Title>
          </Modal.Header>
          {deleteloading ? (
            <div style={{ padding: "20px" }}>
              {" "}
              <b style={{ color: "green" }}>
                {" "}
                Fee Deleting Please Wait{" "}
                <span className="spinner-borderd"></span>
              </b>
            </div>
          ) : (
            <Modal.Footer>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <button
                  onClick={deleteSectionHandle}
                  className="btn button_blue"
                >
                  Delete
                </button>
                <button
                  style={{ marginLeft: "10px" }}
                  onClick={() => setdeleteModal(false)}
                  className="btn btn-danger btn_width"
                >
                  Cancel
                </button>
              </div>
            </Modal.Footer>
          )}
        </Modal>
      </Paper>
    </div>
  );
};

export default ClassSections;
